import { render } from "./userQualityRecord.vue?vue&type=template&id=61450bb6&scoped=true"
import script from "./userQualityRecord.vue?vue&type=script&lang=js"
export * from "./userQualityRecord.vue?vue&type=script&lang=js"

import "./userQualityRecord.vue?vue&type=style&index=0&id=61450bb6&lang=scss&scoped=true"
import "./userQualityRecord.vue?vue&type=style&index=1&id=61450bb6&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61450bb6"]])

export default __exports__